import Tab from "@joinTrilo/ui/atoms/Tab";
import { useCallback } from "react";
import {
    StyledTippingModule,
    StyledTipRow,
    StyledTipWrapper,
} from "./TipModule.styled";

export enum TipType {
    NO_TIP = "NO_TIP",
    FIRST_TIP = "FIRST_TIP",
    SECOND_TIP = "SECOND_TIP",
    THIRD_TIP = "THIRD_TIP",
}

export type Tip = { type: TipType; amount: number; label: string };

export type TipModuleProps = {
    amount: string;
    isLoading: boolean;
    tips: Tip[];
    activeTip?: TipType;
    onTipSelect: (selectedTip: TipType) => Promise<void>;
};

export const TipModule = ({
    tips,
    activeTip,
    onTipSelect,
    isLoading,
}: TipModuleProps) => {
    const handleTipClick = useCallback(
        async (tipType: TipType) => {
            await onTipSelect(tipType); // Notify the parent of the selected tip
        },
        [onTipSelect]
    );

    return (
        <StyledTippingModule>
            <Tab
                tabs={[
                    {
                        key: "addATip",
                        text: "🎁 Add a tip",
                    },
                ]}
            />
            <StyledTipRow>
                {tips.map((tip) => (
                    <StyledTipWrapper
                        key={tip.type}
                        isActive={tip.type === activeTip} // Check if this tip is active
                        isLoading={isLoading}
                        onClick={() => handleTipClick(tip.type)} // Handle click
                    >
                        {tip.label}
                    </StyledTipWrapper>
                ))}
            </StyledTipRow>
        </StyledTippingModule>
    );
};

export default TipModule;
